import { omit, mapValues } from 'lodash';
import { updateIn } from 'icepick';
import coreWebsiteMigrations from 'nucleus-widgets/migrations/website';
import eventWebsiteMigrations from '../migrations/website';

const removeDeletedWidgets = (website, contactCustomFields) => {
  const deleteWidgetIds = Object.keys(website.layoutItems).filter(widgetId => {
    const layoutItem = website.layoutItems[widgetId];
    switch (layoutItem.widgetType) {
      case 'EventCustomContactFieldText':
      case 'EventCustomContactFieldSingleChoice':
      case 'EventCustomContactFieldMultiChoice':
      case 'EventCustomContactFieldDateTime': {
        // Remove custom fields that have been deleted from the account
        const fieldId = layoutItem.config.fieldId;
        return !contactCustomFields[fieldId];
      }
      default:
        return false;
    }
  });

  return updateIn(website, ['layoutItems'], layoutItems =>
    mapValues(omit(layoutItems, deleteWidgetIds), layoutItem =>
      updateIn(layoutItem, ['layout', 'childIds'], childIds => childIds.filter(id => !deleteWidgetIds.includes(id)))
    )
  );
};

export default function transformWebsite(website, account) {
  return eventWebsiteMigrations(
    coreWebsiteMigrations(
      removeDeletedWidgets(website, account.contactCustomFields)
    ));
}
